import axios from 'axios'

export default async function deleteSession(id: string) {
  await axios.delete(`/api/v1/sessions/${id}`, {
    autoLogout: false,
    useRetry: false,
    authHostAsBaseUrl: true,
  })
}
